import uuid from '@/util/uuid'

export default ({
  id,
  radioId,
  frequency,
  originX,
  originY,
  range,
  message
}) => {
  if (!radioId) {
    throw new Error('Missing radioId in radio transmission')
  }

  return {
    id: id || uuid(),
    radioId,
    frequency,
    originX,
    originY,
    range,
    message
  }
}
